import React from 'react';

/**
 * ShareModal - Modal pour afficher le lien de partage d'une collection de biens
 * 
 * @param {boolean} isOpen - État d'ouverture du modal
 * @param {function} onClose - Fonction pour fermer le modal
 * @param {string} shareLink - Lien de partage à afficher
 * @param {number} propertyCount - Nombre de biens partagés
 */
const ShareModal = ({ isOpen, onClose, shareLink, propertyCount }) => {
  console.log('🎨 ShareModal render:', { isOpen, shareLink, propertyCount });
  
  // TEST: Vérifier que le composant se rend
  if (typeof window !== 'undefined') {
    window.SHARE_MODAL_RENDERED = true;
    window.SHARE_MODAL_IS_OPEN = isOpen;
    window.SHARE_MODAL_LINK = shareLink;
  }

  if (!isOpen) {
    console.log('🎨 ShareModal: isOpen=false, pas de rendu');
    return null;
  }

  console.log('🎨 ShareModal: Rendu du modal !');

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareLink);
    alert('✅ Lien copié dans le presse-papiers !');
  };

  const handleClose = () => {
    console.log('🎨 ShareModal: handleClose appelé');
    onClose();
  };

  const handleOpenLink = () => {
    window.open(shareLink, '_blank');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white px-6 py-4 rounded-t-2xl">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-bold flex items-center gap-2">
              <i className="bi bi-share"></i>
              Lien de partage créé
            </h2>
            <button
              onClick={handleClose}
              className="text-white hover:text-gray-200 text-2xl"
            >
              <i className="bi bi-x-lg"></i>
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="p-6">
          <div className="bg-blue-50 border-2 border-blue-200 rounded-lg p-4 mb-4">
            <p className="text-sm text-blue-800 mb-3">
              <i className="bi bi-info-circle mr-2"></i>
              Partagez ce lien avec vos clients. Ils pourront voir les biens sélectionnés sans avoir besoin de se connecter.
            </p>
            <div className="flex gap-2">
              <input
                type="text"
                value={shareLink}
                readOnly
                className="flex-1 px-4 py-3 border-2 border-blue-300 rounded-lg bg-white text-gray-800 font-mono text-sm"
              />
              <button
                onClick={handleCopyLink}
                className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition-all flex items-center gap-2 whitespace-nowrap"
              >
                <i className="bi bi-clipboard"></i>
                Copier
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 text-center">
            <div className="bg-gray-50 rounded-lg p-3">
              <div className="text-2xl font-bold text-blue-600">{propertyCount}</div>
              <div className="text-xs text-gray-600">Bien(s) partagé(s)</div>
            </div>
            <div className="bg-gray-50 rounded-lg p-3">
              <div className="text-2xl font-bold text-green-600">
                <i className="bi bi-infinity"></i>
              </div>
              <div className="text-xs text-gray-600">Vues illimitées</div>
            </div>
            <div className="bg-gray-50 rounded-lg p-3">
              <div className="text-2xl font-bold text-blue-600">
                <i className="bi bi-shield-check"></i>
              </div>
              <div className="text-xs text-gray-600">Lien sécurisé</div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="border-t border-gray-200 px-6 py-4 bg-gray-50 rounded-b-2xl flex justify-between items-center">
          <button
            onClick={handleOpenLink}
            className="text-blue-600 hover:text-blue-700 font-medium flex items-center gap-2"
          >
            <i className="bi bi-box-arrow-up-right"></i>
            Ouvrir le lien
          </button>
          <button
            onClick={handleClose}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
